var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header d-flex justify-content-between" }, [
      _vm._v("\n        " + _vm._s(_vm.$t("Latest changes")) + "\n        "),
      _vm.filteredItems.length > 0 && _vm.clearButton
        ? _c(
            "button",
            {
              staticClass: "btn-clear-history",
              attrs: { id: "clear-history" },
              on: { click: _vm.clearHistory },
            },
            [_vm._v("\n            " + _vm._s(_vm.$t("Clear")) + "\n        ")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.filteredItems.length
      ? _c("div", { staticClass: "history table-responsive" }, [
          _c("table", { staticClass: "history-table table table-main mb-0" }, [
            _c("thead", [
              _c(
                "tr",
                [_vm._t("columns", null, { sortArray: _vm.sortArray })],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.filteredItems, function (model) {
                return _c("tr", [
                  _c("td", [
                    _c("small", { staticClass: "text-muted text-nowrap" }, [
                      _vm._v(_vm._s(_vm._f("datetime")(model.created_at))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    model.href
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: model.href + "?locale=" + model.locale,
                            },
                          },
                          [_vm._v(_vm._s(model.title))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !model.href
                      ? _c("span", [_vm._v(_vm._s(model.title))])
                      : _vm._e(),
                    _vm._v(" "),
                    model.locale
                      ? _c("span", [_vm._v("(" + _vm._s(model.locale) + ")")])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          model.historable_type.substring(
                            model.historable_type.lastIndexOf("\\") + 1
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "action" }, [
                    _c("small", { staticClass: "action-content" }, [
                      _c("span", {
                        staticClass: "icon",
                        class: "icon-" + model.action,
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(model.action) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("small", { staticClass: "user-name" }, [
                      _vm._v(_vm._s(model.user_name)),
                    ]),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ])
      : _c("div", { staticClass: "card-body" }, [
          _vm.loading
            ? _c("div", [
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("Loading…"))),
                ]),
              ])
            : _c("div", [
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(
                    _vm._s(
                      _vm.searchString !== ""
                        ? _vm.$t("Nothing found.")
                        : _vm.$t("History is empty.")
                    )
                  ),
                ]),
              ]),
        ]),
    _vm._v(" "),
    _vm.filteredItems.length > 0 && _vm.data.total > _vm.data.per_page
      ? _c(
          "div",
          { staticClass: "card-footer" },
          [
            _vm.pagination
              ? _c("item-list-pagination", {
                  staticClass: "justify-content-center",
                  attrs: { data: _vm.data },
                  on: { "pagination-change-page": _vm.changePage },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }